<template>
  <v-layout justify-center>
  </v-layout>
</template>

<script>
/* eslint-disable no-debugger */
export default {
  data:() => ({   
  }),
  created() {
      this.$store.commit("setToken", "");
      //this.$store.commit("setMenuOptions", [])
      //alert("log out users")
      //debugger;
     this.$router.push("login");
     //this.$router.push({path: "login"});
     //  window.location.href = "/#/login" 
  }
}
</script>

<style>
</style>
